/**
 * Deutsch (de) — a partial of `content/en.ts`.
 *
 * Anything omitted renders in English, on purpose. Only the interface strings
 * are translated so far: the marketing copy in the base file is placeholder,
 * and translating placeholder copy is work that has to be thrown away twice.
 */
import type { Translation } from '@/i18n/dictionary'

export const de: Translation = {
  nav: {
    languageLabel: 'Sprache',
    skipToContent: 'Zum Inhalt springen',
    cta: { label: 'Sprechen Sie uns an' },
  },
  contactBand: {
    heading: 'Lassen Sie uns sprechen!',
    cta: { label: 'Sprechen Sie uns an' },
    photoAlt: 'Farbenfrohe Kakteen, umrahmt von einem Digitopia-Gradient-Ribbon',
  },
  footer: {
    rights: 'Alle Rechte vorbehalten.',
  },
  preview: {
    badge: 'Vorschau',
    notice: 'Dies ist eine nicht freigegebene Vorschau von digitopia.ai. Die Inhalte sind ein Entwurf.',
  },
  ui: {
    previous: 'Zurück',
    next: 'Weiter',
  },
}
